export const SELECTED_TASK_IDS_CHANGE = 'at/taskManagement/SELECTED_TASK_IDS_CHANGE'
export const LOAD_EXISTING_TASK_IDS = 'at/taskManagement/LOAD_EXISTING_TASK_IDS'
export const LOAD_EXISTING_TASK_IDS_SUCCESS = 'at/taskManagement/LOAD_EXISTING_TASK_IDS_SUCCESS'
export const LOAD_EXISTING_TASK_IDS_FAILURE = 'at/taskManagement/LOAD_EXISTING_TASK_IDS_FAILURE'
export const PENDING_SELECT_ALL_SET = 'at/taskManagement/PENDING_SELECT_ALL_SET'
export const PENDING_SELECT_ALL_RESET = 'at/taskManagement/PENDING_SELECT_ALL_RESET'
export const EXISTING_TASK_IDS_BY_FILTERS_SET = 'at/taskManagement/EXISTING_TASK_IDS_BY_FILTERS_SET'
export const EXISTING_TASK_IDS_LOADED_RESET = 'at/taskManagement/EXISTING_TASK_IDS_LOADED_RESET'



// WEBPACK FOOTER //
// ./web/js/taskManagement/taskSelection/actionTypes.js